"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const NavigateBeforeIcon_1 = __importDefault(require("./NavigateBeforeIcon"));
const NavigateNextIcon_1 = __importDefault(require("./NavigateNextIcon"));
function Pagination({ onChangePage, page, totalPages }) {
    function changePage(event, newPage) {
        event.preventDefault();
        if (onChangePage) {
            onChangePage(newPage);
        }
    }
    // eslint-disable-next-line react/prop-types
    const Page = ({ current, number }) => ((0, jsx_runtime_1.jsx)("li", { className: "usa-pagination__item usa-pagination__page-no", children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (e) => changePage(e, number), className: (0, uswds_react_utils_1.createClassString)('usa-pagination__button', current && 'usa-current'), "aria-label": `${number === totalPages ? 'last page, ' : ''}page ${number}`, "aria-current": current ? 'page' : undefined, children: number }) }, `page-${page}`));
    const Overflow = () => ((0, jsx_runtime_1.jsx)("li", { className: "usa-pagination__item usa-pagination__overflow", role: "presentation", children: (0, jsx_runtime_1.jsx)("span", { children: " \u2026 " }) }));
    const slots = [];
    const unbounded = totalPages === undefined || totalPages === null;
    let midPagesToShow = unbounded ? 4 : 3;
    if (!unbounded && totalPages <= 7) {
        midPagesToShow = 0;
    }
    if (midPagesToShow) {
        slots.push((0, jsx_runtime_1.jsx)(Page, { current: page === 1, number: 1 }, "page-1"));
        let midStart = page - 1;
        if (midStart > 2)
            slots.push((0, jsx_runtime_1.jsx)(Overflow, {}, "first-page-gap"));
        else {
            slots.push((0, jsx_runtime_1.jsx)(Page, { current: page === 2, number: 2 }, "page-2"));
            midStart = 3;
        }
        let endOverflow = true;
        if (!unbounded) {
            const tillEnd = totalPages - page + 1;
            if (tillEnd < 4) {
                midStart = totalPages - 4;
                midPagesToShow = 4;
                endOverflow = false;
            }
        }
        for (let i = 0; i < midPagesToShow; i++) {
            const pageNum = midStart + i;
            slots.push((0, jsx_runtime_1.jsx)(Page, { current: page === pageNum, number: pageNum }, `page-${pageNum}`));
        }
        if (endOverflow)
            slots.push((0, jsx_runtime_1.jsx)(Overflow, {}, "second-page-gap"));
        if (!unbounded) {
            slots.push((0, jsx_runtime_1.jsx)(Page, { current: page === totalPages, number: totalPages }, `page-${totalPages}`));
        }
    }
    else if (totalPages) {
        for (let i = 1; i <= totalPages; i++) {
            slots.push((0, jsx_runtime_1.jsx)(Page, { current: page === i, number: i }, `page=${i}`));
        }
    }
    return ((0, jsx_runtime_1.jsx)("nav", { "aria-label": "Pagination", className: "usa-pagination", children: (0, jsx_runtime_1.jsxs)("ul", { className: "usa-pagination__list", children: [page > 1 && ((0, jsx_runtime_1.jsx)("li", { className: "usa-pagination__item usa-pagination__arrow", children: (0, jsx_runtime_1.jsxs)("a", { href: "#", onClick: (e) => changePage(e, page - 1), className: "usa-pagination__link usa-pagination__previous-page", "aria-label": "Previous page", children: [(0, jsx_runtime_1.jsx)(NavigateBeforeIcon_1.default, { className: "usa-icon", role: "img", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("span", { className: "usa-pagination__link-text", children: " Previous " })] }) })), slots.map((slot) => slot), ((totalPages && page < totalPages) || unbounded) && ((0, jsx_runtime_1.jsx)("li", { className: "usa-pagination__item usa-pagination__arrow", children: (0, jsx_runtime_1.jsxs)("a", { href: "#", onClick: (e) => changePage(e, page + 1), className: "usa-pagination__link usa-pagination__next-page", "aria-label": "Next page", children: [(0, jsx_runtime_1.jsx)("span", { className: "usa-pagination__link-text", children: " Next " }), (0, jsx_runtime_1.jsx)(NavigateNextIcon_1.default, { className: "usa-icon", role: "img", "aria-hidden": "true" })] }) }))] }) }));
}
exports.default = Pagination;
